import {OtsUIState} from "../../ots-ui-store";

export const selectUIActivityPeriodSearchFilter = (state: OtsUIState) => state.uiActivityPeriod.searchFilter
